// Admin authentication utilities

export const getApiKey = () => {
  // Try localStorage with different key variations, then environment variable, then fallback
  return window.localStorage.getItem('ADMIN_API_KEY') || 
         window.localStorage.getItem('adminApiKey') ||
         window.localStorage.getItem('adminKey') ||
         process.env.REACT_APP_ADMIN_API_KEY || 
         'dev-admin-key-sonic-cart-2024-secure';
};